import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as artists from '@webapp/sdk/artists';
import { promiseDelay } from '@webapp/utils/promise-delay';
import { Actions } from '../../actions';
import {
  DeactivateArtist,
  DeactivateArtistSuccess,
  DeactivateArtistError,
} from '../action-creators';
import { DEACTIVATE_ARTIST } from '../actions';
import { StartLoading } from '../../ui/action-creators';
import store from '../../index';

export const deactivateArtistEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, DeactivateArtist>(DEACTIVATE_ARTIST),
    mergeMap(async (action) => {
      store.dispatch(new StartLoading(DEACTIVATE_ARTIST, true));

      try {
        await artists.deactivate(action.artist.id);
        await promiseDelay(500);
        return new DeactivateArtistSuccess(action.artist);
      } catch (err) {
        return new DeactivateArtistError(err.message);
      }
    })
  );
